import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";

export function useDeleteSirenPortalBranding() {
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const deleteBranding = useCallback(async (id: string) => {
        setDeleting(true);
        setError(null);
        try {
            await platformAPI.delete(`api/siren/branding/${id}`);
        } catch {
            setError("Failed to delete siren branding");
            throw new Error("Failed to delete siren branding");
        } finally {
            setDeleting(false);
        }
    }, []);

    return {deleteBranding, deleting, error};
}
